const PopularData = [
  {
    id: 1,
    image: "images/myimages/222.jpg",
  },
  {
    id: 2,
    image: "images/newimages/1.jpg",
  },
  {
    id: 3,
    image: "images/newimages/2.jpg",
  },
  {
    id: 4,
    image: "images/newimages/6.jpg",
  },
  {
    id: 5,
    image: "images/newimages/4.jpg",
  },
  {
    id: 6,
    image: "images/newimages/5.jpg",
  },
  {
    id: 7,
    image: "images/newimages/3.jpg",
  },
  {
    id: 8,
    image: "images/newimages/8.jpg",
  },

  {
    id: 9,
    image: "images/newimages/9.jpg",
  },
  {
    id: 10,
    image: "images/newimages/10.jpg",
  },
  {
    id: 11,
    image: "images/newimages/11.jpg",
  },
  {
    id: 12,
    image: "images/newimages/12.jpg",
  },
  {
    id: 13,
    image: "images/newimages/13.jpg",
  },
  {
    id: 14,
    image: "images/newimages/14.jpg",
  },
  {
    id: 15,
    image: "images/newimages/15.jpg",
  },
];

export default PopularData;
